import { SelectDataType } from "@sso/components/Form";

import { TraccUsageKeys } from "../constant/traccUsage";

export enum CalculationType {
  None = "None",
  ORIGIN_DESTINATION = "OriginDestination",
  ARRIVE_BY_DEPART_AT = "ArriveByDepartAt",
  PTAL = "PTAL",
  LOCAL_ACCESSIBILITY = "LocalAccessibility",
}

export const calculationTypeOption: SelectDataType[] = [
  { key: CalculationType.ORIGIN_DESTINATION, value: CalculationType.ORIGIN_DESTINATION, label: "Origin Destination" },
  { key: CalculationType.ARRIVE_BY_DEPART_AT, value: CalculationType.ARRIVE_BY_DEPART_AT, label: "ArriveBy/DepartAt" },
  { key: CalculationType.PTAL, value: CalculationType.PTAL, label: "PTAL" },
  { key: CalculationType.LOCAL_ACCESSIBILITY, value: CalculationType.LOCAL_ACCESSIBILITY, label: "Local Accessibility" },
];

export interface TraccUsage {
  [TraccUsageKeys.FULL_NAME]: string;
  [TraccUsageKeys.EMAIL]: string;
  [TraccUsageKeys.ORGANISATION_NAME]: string;
  [TraccUsageKeys.CALCULATION_TYPE]: string;
  [TraccUsageKeys.CREATED_AT]: Date;
  [TraccUsageKeys.USER_NAME]: string;
}